import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
    getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { calendarIcon, groupIcon, ownershipIcon, smartTvIcon } from "./assets";
// Customizable Area Start
// Customizable Area End

export const webConfigJSON = require("./config.js");

export interface Props {
    navigation: any;
    // Customizable Area Start
    classes: any;
    checked: boolean
    // Customizable Area End
}
interface S {
    // Customizable Area Start
    minimum_payment: number;
    total_earning: number;
    current_month_earning: number;
    progressPercentage: number;
    // Customizable Area End
}
interface SS { }

export default class EarningsController extends BlockComponent<Props, S, SS> {
    // Customizable Area Start
    earningsOptionsList = [
        {
            label: 'Referral Revenue',
            icon: groupIcon,
        },
        {
            label: 'Subscriptions Revenue',
            icon: calendarIcon,
        },
        {
            label: 'Ads Revenue',
            icon: smartTvIcon,
        },
        {
            label: 'Ownership',
            icon: ownershipIcon,
        },
    ];
    totalRevenueApiCallId: string = '';
    paymentActivitiesApiCallId: string = '';

    constructor(props: Props) {
        super(props);
        this.receive = this.receive.bind(this);

        this.subScribedMessages = [
            getName(MessageEnum.RestAPIResponceMessage),
        ];

        this.state = {
            total_earning: 0,
            minimum_payment: 0,
            current_month_earning: 0,
            progressPercentage: 0,
        };

        runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    }

    async componentDidMount() {
        super.componentDidMount();
        this.getTotalRevenue();
    }

    async receive(from: string, message: Message) {
        if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
            const webApiRequestCallId = message.getData(
                getName(MessageEnum.RestAPIResponceDataMessage)
            );

            let webResponseJson = message.getData(
                getName(MessageEnum.RestAPIResponceSuccessMessage)
            );

            if (webResponseJson && !webResponseJson.errors) {
                if (webApiRequestCallId === this.totalRevenueApiCallId) {
                    this.setState({
                        minimum_payment: webResponseJson.minimum_payment ?? 0,
                        total_earning: webResponseJson.total_earning ?? 0,
                        current_month_earning: webResponseJson.current_month_earning ?? 0,
                    }, () => {
                        this.calculateProgress();
                    });
                }
            }
        }
    }

    getTotalRevenue = () => {
        const token = localStorage.getItem("authToken");
        const headers = {
            'Content-Type': webConfigJSON.dashboarContentType,
            token,
        };

        const requestMessage = new Message(
            getName(MessageEnum.RestAPIRequestMessage)
        );

        this.totalRevenueApiCallId = requestMessage.messageId;

        requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), webConfigJSON.totalRevenueEndPoint);
        requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), webConfigJSON.dashboarApiMethodType);
        requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), headers);

        runEngine.sendMessage(requestMessage.id, requestMessage)
    }

    navigationHandler = (label: string) => {
        const { navigate } = this.props.navigation;

        switch (label) {
            case 'Ownership':
                navigate('OwnershipScreen');
                break;

            case 'Payment Activity':
                navigate('PaymentActivities');
                break;

            default:
                navigate('RevenueScreen', { type: label });
                break;
        }
    }

    calculateProgress = () => {
        const { minimum_payment, current_month_earning } = this.state;
        if (current_month_earning === 0 || minimum_payment === 0) {
            return 0;
        }
        const percentage = (current_month_earning / minimum_payment) * 100;
        this.setState({ progressPercentage: percentage > 100 ? 100 : percentage });
    }
    // Customizable Area End
}
